import React from 'react';
import { ProposalForm } from './view/proposalForm';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'ProposalForm', 
  itemElt: (item, cmsOption) => <ProposalForm item={item} cmsOption={cmsOption} />
}